import { Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { MinimumDeliveryReportStep } from './MinimumDeliveryReportStep'
import { TimeOfBirthStep } from './TimeOfBirthStep'

type ReportBirthStep = 'time-of-birth' | 'minimum-report'

interface ReportBirthModalProps {
  isOpen: boolean
  onClose: () => void
}

export const ReportBirthModal = ({ isOpen, onClose }: ReportBirthModalProps) => {
  const [step, setStep] = useState<ReportBirthStep>('time-of-birth')
  const [timeOfBirth, setTimeOfBirth] = useState<number | null>(null)

  const handleTimeOfBirthSaved = (tob: number) => {
    setTimeOfBirth(tob)
    setStep('minimum-report')
  }

  const handleMinimumReportComplete = () => {
    // Reset for next time
    setStep('time-of-birth')
    setTimeOfBirth(null)
    onClose()
  }

  const stepTitle =
    step === 'time-of-birth'
      ? 'Report Birth — Step 1 of 2'
      : 'Minimum Delivery Report — Step 2 of 2'

  return (
    <Modal
      isOpen={isOpen}
      onClose={step === 'time-of-birth' ? onClose : () => {}}
      // §4.1.2: Provider must complete minimum report before closing — no escape after step 1
      closeOnOverlayClick={step === 'time-of-birth'}
      closeOnEsc={step === 'time-of-birth'}
      size="lg"
      isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={8} mx={4}>
        <ModalBody p={0}>
          <Flex direction="column">
            {/* Header */}
            <Flex
              align="center"
              px={5}
              py={4}
              borderBottom="1px solid"
              borderColor="pink.200"
              bg="pink.50"
              borderTopRadius={8}
              _dark={{ bg: 'pink.900', borderBottomColor: 'pink.700' }}>
              <Text
                fontFamily="Hero-New"
                fontWeight={700}
                fontSize="lg"
                color="pink.700"
                _dark={{ color: 'pink.200' }}>
                {stepTitle}
              </Text>
            </Flex>

            {/* Step content */}
            {step === 'time-of-birth' && <TimeOfBirthStep onSaved={handleTimeOfBirthSaved} />}
            {step === 'minimum-report' && timeOfBirth != null && (
              <MinimumDeliveryReportStep
                timeOfBirth={timeOfBirth}
                onComplete={handleMinimumReportComplete}
              />
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
